import { createAsyncThunk } from '@reduxjs/toolkit';
import { CategoryProgramService } from 'Services/axios/CategoryProgram.Service';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchCategoryProgram = createAsyncThunk(
  'CategoryProgram/fetchCategoryProgram',
  async (filters) => {
    try {
      const response = await CategoryProgramService.getAll(filters);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const getMainProgramCategory = createAsyncThunk(
  'CategoryProgram/getMainProgramCategory',
  async () => {
    try {
      const response = await CategoryProgramService.getMainProgram();
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitCategoryProgram = createAsyncThunk(
  'addCategoryProgram/submitCategoryProgram',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('parent_name', data.name);
      formData.append('parent_slug', data.slug);
      data.children.forEach((child, index) => {
        if (data.isUpdate) {
          formData.append(`child[${index}][id]`, child.id !== undefined ? child.id : '');
          formData.append(`child[${index}][name]`, child.name);
          formData.append(`child[${index}][slug]`, child.slug);
        } else {
          formData.append(`child[${index}][name]`, child.name);
          formData.append(`child[${index}][slug]`, child.slug);
        }
      });

      let response;
      if (data.isUpdate) {
        response = await CategoryProgramService.update(data.id, formData);
      } else {
        response = await CategoryProgramService.create(formData);
      }
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteCategoryProgram = createAsyncThunk(
  'deleteCategoryProgram/deleteCategoryProgram',
  async (id) => {
    try {
      const response = await CategoryProgramService.delete(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);


